// ant
import { Checkbox, Form } from 'antd'
import { CheckboxGroupProps } from 'antd/lib/checkbox'
import { FormItemProps } from 'antd/lib/form/FormItem'
import React from 'react'
import { WrappedFieldProps } from 'redux-form'
import { useTranslation } from 'react-i18next'

// utils
import { FORM_TEMPLATE_TYPES } from '../utils/enums'

const { Item } = Form

type ComponentProps = {
	disabled?: boolean
}

type Props = WrappedFieldProps & CheckboxGroupProps & FormItemProps & ComponentProps

const TypeCheckboxGroupField = (props: Props) => {
	const { t } = useTranslation()
	const {
		input,
		label,
		required,
		meta: { error, touched },
		style,
		defaultValue,
		disabled
	} = props

	return (
		<Item label={label} required={required} help={touched && error} validateStatus={error && touched ? 'error' : undefined} style={style}>
			<Checkbox.Group
				className={'flex flex-wrap'}
				value={input.value || []}
				onChange={input.onChange}
				defaultValue={defaultValue}
				disabled={disabled || false}
			>
				<div className={'type-checkbox-button'}>
					<Checkbox key={FORM_TEMPLATE_TYPES.INBOUND} value={FORM_TEMPLATE_TYPES.INBOUND}>
						{t('loc: Inbound')}
					</Checkbox>
					<Checkbox key={FORM_TEMPLATE_TYPES.OUTBOUND} value={FORM_TEMPLATE_TYPES.OUTBOUND} className={'ml-5'}>
						{t('loc: Outbound')}
					</Checkbox>
				</div>
			</Checkbox.Group>
		</Item>
	)
}

export default TypeCheckboxGroupField
